/** Ask the conceptual Helper agent and preserve its Analyst handoff signal. */
export const requestHelperAnswer = async (prompt) => {
  const baseURL = (typeof window !== 'undefined' && window.location?.origin) || '';
  const response = await fetch(`${baseURL}/ai-explorer/api/v1/helper/echo-prompt`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`,
    },
    body: JSON.stringify({ prompt }),
  });

  if (!response.ok) throw new Error(`Helper error (${response.status})`);

  const data = await response.json();
  return {
    response: data.response ?? data.prompt ?? JSON.stringify(data),
    routeToAnalyst: data.route_to_analyst === true,
  };
};
